<template>
  <Bar :data="chartData" :options="chartOptions" />
</template>

<script setup>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { computed } from "vue";
import { Bar } from "vue-chartjs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const props = defineProps({
  datasets: {
    type: Array,
    required: true,
  },
  labels: {
    type: Array,
    required: true,
  }
});

function getFgColor() {
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue("--fg1")
      .trim() || "#222"
  );
}
const chartData = computed(() => ({
  labels: props.labels,
  datasets: props.datasets,
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  //   indexAxis: "y",
  plugins: {
    legend: {
      display: true,
      position: "top",
      align: "center",
      labels: {
        color: getFgColor(),
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        color: getFgColor(),
      },
      grid: {
        color: getFgColor(),
      },
    },
    y: {
      stacked: true,
      ticks: {
        color: getFgColor(),
      },
      grid: {
        color: getFgColor(),
      },
    },
  },
};
</script>
